import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getTeam } from '@sportninja/common/services/team/getTeam'
import parsers from '@sportninja/common/reducers/parsers'
import { ENTITY_TYPES } from '@sportninja/common/sagas/utils'

/**
 * Loads the FULL team behind a tree node, for the edit modal.
 *
 * The operations tree carries only what its rows draw (id, name, seed, image,
 * games count) — not the contact fields, visibility flags or background image
 * the edit form writes back. Seeding `TeamModal` from a tree node therefore
 * rendered those fields blank and PUT the blanks back to the server, wiping
 * them; the logo field showed its "Click to Upload" placeholder on a team that
 * already had one.
 *
 * Returns the payload already run through the shared team parser, which is the
 * shape `TeamModal` expects (see `pages/Team/index.jsx`, which does the same).
 */
export const useTeamForEdit = (teamId: string | null) => {
  'use memo'

  const query = useQuery({
    queryKey: queryKeys.team.byId(teamId),
    queryFn: () => getTeam(teamId as string),
    enabled: Boolean(teamId),
  })

  const team = query.data
    ? (parsers[ENTITY_TYPES.team](query.data) as Record<string, unknown>)
    : undefined

  return { team, isLoading: query.isLoading, isError: query.isError }
}
